<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<p class="half">Battleground</p>
<h1 class="title">From the Channel to the  Ypres Salient</h1>
<p class="sub-title1">The Belgian Sector 1914–1918</p>
<p class="author">Chris Baker</p>
<p class="authort"><em class="italic">Series Editor</em></p>
<p class="author1">Nigel Cave</p>
<div class="img_containerp">
<img alt="images" src="images/f000iii-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?433661fc